import { ItiBaseDto } from './iti-base-dto';

export class ItiMessageListenFor extends ItiBaseDto {
    public EventName!: string;
    public EventMethod!: (...args: any[]) => void;
}
